@if (image()) {
    <sirius-image-item
        [image]="image()"
        [imageData]="imageData()"
        [alt]="accessibleLabel()"
        objectFit="cover"
        [round]="true"
        [itemprop]="itemprop()"
    >
    </sirius-image-item>
} @else {
    {{ initials() }}
}
